<ng-container>
    {{ sortDirection === 0 ? '↥' : '↧' }}
</ng-container>

